import { API } from '../api'
import { Unit } from './interface'

export const get = async (
  filtros: Record<string, any>
): Promise<{
  content: string
}> => {
  try {
    const response = await API.get<Unit>('/logistica/item/obter', {
      ...filtros
    })

    return response
  } catch (error) {
    console.error('Erro ao buscar unidade:', error)
    return null
  }
}
